<script lang="ts">
    import * as echarts from 'echarts';
    import { _ } from 'svelte-i18n';

    import WidgetTemplateInner from '../../../../shared/Dashboard/WidgetTemplateInner.svelte';
    import {
        type DashboardComponentType,
        WidgetManager,
    } from '../../../../shared/Dashboard/WidgetManager';
    import { z } from 'zod';
    import GanttCouriers from '../../../GanttCouriers/GanttCouriers.svelte';
    import {
        GanttCouriersSettings,
        GanttCouriersSettingsModeType,
    } from '../../../GanttCouriers/GanttCouriersSettings';
    import Select from '../../../../shared/Select.svelte';
    import Switch from '../../../../shared/Switch.svelte';
    import { customerSettings } from '../../../../../stores/api';

    export let dashboardItem: DashboardComponentType;
    export let widgetManager: WidgetManager;

    let ganttCouriersSettings: GanttCouriersSettings = new GanttCouriersSettings()
        .setAssignmentIds([])
        .setSimpleView(false)
        .setMode(GanttCouriersSettingsModeType.PLANNED)
        .setRouteStopTimes(
            $customerSettings.each_stop_minutes,
            $customerSettings.each_delivery_minutes
        );

    const defaultChartOption: echarts.EChartsOption = {
        grid: {
            containLabel: true,
            left: '10%',
            right: '10%',
            top: 0,
            bottom: 0,
        },
        series: [],
    };

    const GanttCouriersApiSchema = z.object({
        assignmentIds: z.array(z.number()),
        dataMode: z.nativeEnum(GanttCouriersSettingsModeType),
        selectedDay: z.string(),
    });
    type GanttCouriersApiSchemaType = z.infer<typeof GanttCouriersApiSchema>;

    dashboardItem.we.setChartOption(defaultChartOption);
    dashboardItem.we.setDataSchema(GanttCouriersApiSchema);
    dashboardItem.we.setUpdateFunction((defaultChartOption, data: GanttCouriersApiSchemaType) => {
        console.log('GanttCouriers, data', data);
        ganttCouriersSettings.setAssignmentIds(data.assignmentIds);
        // ganttCouriersSettings.setMode(data.dataMode);
        ganttCouriersSettings = ganttCouriersSettings;
    });

    $: dashboardItem = dashboardItem;
    $: widgetManager = widgetManager;

    let timelineMode: boolean = false;

    $: {
        if (timelineMode) {
            ganttCouriersSettings.setTimelineView();
            console.log('ganttCouriersSettings setTimelineView');
        } else {
            // ganttCouriersSettings.setDataView();
            ganttCouriersSettings.setSimpleView(false);
            console.log('ganttCouriersSettings setDataView');
        }
        ganttCouriersSettings = ganttCouriersSettings;
    }
</script>

<WidgetTemplateInner bind:widgetManager {dashboardItem} chartVisible={false}>
    <div class="widget-container-gantt-couriers">
        <div style="margin-bottom: 10px;">
            <!--            <Switch label="Timeline" bind:checked={timelineMode} />-->
            <Select
                items={[
                    {
                        id: GanttCouriersSettingsModeType.PLANNED,
                        label: $_('route_planned'),
                    },
                    // {
                    //     id: GanttCouriersSettingsModeType.CURRENT,
                    //     label: GanttCouriersSettingsModeType.CURRENT,
                    // },
                    {
                        id: GanttCouriersSettingsModeType.APPROACHED,
                        label: $_('route_executed'),
                    },
                ]}
                selected={ganttCouriersSettings.dataMode}
                onChange={s => {
                    ganttCouriersSettings.setMode(s);
                    ganttCouriersSettings.tickCounter();
                    ganttCouriersSettings = ganttCouriersSettings;
                    return true;
                }}
            />
        </div>
        <GanttCouriers {ganttCouriersSettings} />
    </div>
</WidgetTemplateInner>

<style>
    .widget-container-gantt-couriers {
        padding: 10px 20px 0 20px;
        overflow: hidden;
        height: 90%;
        max-height: 380px; /* see: .dashboard-item.double-height-item */
        /*overflow-x: visible;*/
        overflow-y: auto;
    }
</style>
